import { Grid, useEventCallback } from '@mui/material';
import { memo } from 'react';
import { FormikErrors, FormikTouched } from 'formik';
import { SectionVM } from 'civil-status/view-models/step-form';
import ForeignStateList, { ForeignStateVM } from 'shell/components/shared/foreign-state-list';
import ListAnsc from '../../../../../../../shared/list-ansc';
import { ItemVM } from 'shell/view-models/item';

interface CitizenshipCit08Props {
  disabled?: boolean;
  values?: SectionVM;
  errors?: FormikErrors<SectionVM>;
  touched?: FormikTouched<SectionVM>;
  onChange: (key: keyof SectionVM, value: SectionVM[keyof SectionVM]) => void;
  configuration?: string;
}

const CitizenshipCit08Component = ({
  disabled = false,
  values,
  errors,
  touched,
  onChange,
}: CitizenshipCit08Props): React.ReactElement => {
  const handleListTypeService = useEventCallback((item?: ItemVM) => {
    onChange('typeService', item?.id);
  });

  const handleNationEmploymentStateListChange = useEventCallback(
    (state: ForeignStateVM | null | undefined) => {
      onChange('nationEmployment', state);
    }
  );

  return (
    <Grid container spacing={2} item>
      <Grid item xs={12} md={6}>
        <ListAnsc
          label="Tipo servizio reso"
          idDominio="44"
          value={values?.typeService || ''}
          onChange={handleListTypeService}
          disabled={disabled}
          error={Boolean(errors?.typeService) && touched?.typeService}
          required
        />
      </Grid>
      <Grid item xs={12} md={6}>
        <ForeignStateList
          value={values?.nationEmployment || null}
          onChange={handleNationEmploymentStateListChange}
          required
          disabled={disabled}
          label="Nazione impiego"
          id="nationEmployment"
          error={
            (touched?.nationEmployment as unknown as FormikTouched<ForeignStateVM>) &&
            Boolean(errors?.nationEmployment as FormikErrors<ForeignStateVM>)
          }
        />
      </Grid>
    </Grid>
  );
};

CitizenshipCit08Component.displayName = 'Form Citizenship Cit 08 Request component';

const CitizenshipCit08 = memo(CitizenshipCit08Component);

export default CitizenshipCit08;
